module.exports={
	"Form": "DocumentApprovalStepEditManifest",
	"Scope": "DocumentApprovalStep-Edit",
	"Descriptors":
	{
		"DocumentApprovalStepDetails.IDDocumentApprovalStep":
		{
			"Name": "ID",
			"Hash": "DocStepEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "DocStepEditIdentity",
				"Group": "DocStepEditIdentity"
			}
		},
		"DocumentApprovalStepDetails.GUIDDocumentApprovalStep":
		{
			"Name": "GUID",
			"Hash": "DocStepEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "DocStepEditIdentity",
				"Group": "DocStepEditIdentity"
			}
		},
		"DocumentApprovalStepDetails.IDDocumentApprovalState":
		{
			"Name": "State ID",
			"Hash": "DocStepEdit-IDState",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepEditConfig",
				"Group": "DocStepEditConfig"
			}
		},
		"DocumentApprovalStepDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "DocStepEdit-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepEditConfig",
				"Group": "DocStepEditConfig"
			}
		},
		"DocumentApprovalStepDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "DocStepEdit-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "DocStepEditConfig",
				"Group": "DocStepEditConfig"
			}
		},
		"DocumentApprovalStepDetails.IncludeHigherRoles":
		{
			"Name": "Include Higher Roles",
			"Hash": "DocStepEdit-HigherRoles",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "DocStepEditConfig",
				"Group": "DocStepEditConfig"
			}
		},
		"DocumentApprovalStepDetails.PerformLock":
		{
			"Name": "Perform Lock",
			"Hash": "DocStepEdit-PerformLock",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 3,
				"Section": "DocStepEditConfig",
				"Group": "DocStepEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "DocStepEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "DocStepEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Step Configuration",
			"Hash": "DocStepEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Step Configuration",
					"Hash": "DocStepEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
